module.exports = __webpack_public_path__ + "img/text-effect-circle.b0278cb4.png";